<template>
  <div>
    <h1>redundant page only used for physical business card qr code, set to redirect to home page</h1>
  </div>
</template>
<script>
export default {
  name: 'BusinessCard'
}
</script>